<template>
  <div class="vouch">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="header">
      <div class="headTitle">
        <img class="headIcon" src="@/assets/image/AccountDeal/gameSelectHead/vouchIcon.png">
        <div class="headText">{{ step === 1 ? '担保中介' : '担保中介 - 收费明细' }}</div>
        <div class="headTip" v-if="step===1">选择游戏后跳转客服</div>
      </div>
      <router-link :to="{name:'Home'}" class="headBack" v-if="step===1">返回首页</router-link>
      <div class="headBack" v-else @click="backBtn">返回</div>
    </div>
    <!--  游戏列表 gameList -->
    <div class="gameList" v-if="step===1">
      <gameList :gameClick="gameClick" other vouch></gameList>
    </div>
    <!--  游戏列表 gameList -->
    <div class="gameInfo" v-if="step===2">
      <div class="select">
        <img :src="selectGame.game_image" alt="" class="img">
        <div class="info">
          <div class="name">{{ selectGame.game_name }}</div>
          <div class="cost">{{ selectGame.media_guarantee }}</div>
        </div>
        <!--        <a target="_blank" class="btn" @click="$accessLink(selectGame.sell_customer)"-->
        <!--           :href="`${selectGame.sell_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`">联系客服</a>-->
      </div>
      <div class="wechatList" v-if="selectGame.sys_service_type==2" style="padding:0;">
        <a :class="item.isonline === 1 ?'':'afterWork'" class="cusSer QQSGcusSer" v-for="(item,index) in cursList"
            :key="index" @click="customClicks(item)" target="_blank">
          <div class="cus-head">
            <img src="@/assets/image/Home/cusSerCenterIcon.png">
          </div>
          <div class="name">{{ item.nickname }}</div>
          <div class="division"></div>
          <a class="btn" v-if="item.isonline === 1" @click.stop="customClicks(item)" target="_blank">咨询客服</a>
          <a class="btn" v-else target="_blank">客服不在线</a>
        </a>
        <!-- <a :class="item.is_work === 0 ?'afterWork':''" class="cusSer" v-for="(item,index) in selectGame.buy_list" :key="index" @click="customClick(item)" target="_blank">
          <div class="info">
            <img src="@/assets/image/Home/cusSerCenterIcon.png" alt="">
            <div class="name">{{ item.work_name }}</div>
          </div>
          <a class="btn" @click.stop="customClick(item)" v-if="item.is_work === 1" target="_blank">咨询客服</a>
          <a class="btn"  v-else target="_blank">客服不在线</a>
        </a> -->
      </div>
      <div class="wechatList" v-else-if="selectGame.sys_service_type===3" style="padding:0;">
        <a :class="item.session_info && item.session_info.status === 0 ?'':'afterWork'" class="cusSer QQSGcusSer" v-for="(item,index) in cursList"
            :key="index" @click="customClicks(item)" target="_blank">
          <div class="cus-head">
            <img src="@/assets/image/Home/cusSerCenterIcon.png">
          </div>
          <div class="name">{{ item.nickname }}</div>
          <div class="division"></div>
          <a class="btn" v-if="item.session_info && item.session_info.status === 0" @click.stop="customClicks(item)" target="_blank">咨询客服</a>
          <a class="btn" v-else target="_blank">客服不在线</a>
        </a>
      </div>
      <div class="wechatList" v-else>
        <a :class="item.is_work === 0 ?'afterWork':''" class="cusSer" v-for="(item,index) in selectGame.buy_list"
            :key="index" @click="customClick(item)" target="_blank">
          <div class="info">
            <div class="name">{{ item.work_name }}</div>
            <div class="qr_code">
              <img :src="item.qr_code_url" alt="">
            </div>
            <div class="tip">
              <img src="@/assets/image/CusSerCenter/scanCode.png" alt="">
              微信扫码
            </div>
          </div>
          <a class="btn" v-if="item.is_work === 0" target="_blank">客服不在线</a>
          <a class="btn" @click.stop="customClick(item)" v-else target="_blank">咨询客服</a>
        </a>
      </div>
      <!--      <div class="wechatList" v-if="selectGame.wechat_list.length>0">
              <div class="title">
                <span><img src="@/assets/image/Home/sellPop/vouchIcon1.png" alt="">微信扫码</span>
                ，添加游严选官方客服快速咨询～
              </div>
              <div class="wehcatBox">
                <div class="wechatItem" v-for="(item,index) in selectGame.wechat_list" :key="index" @click="onlineCusSer(selectGame,item)">
                  <div class="wechatType">{{item.type===0?'客服微信':'企业微信'}}</div>
                  <img class="wechatImg" :src="item.imgurl" alt="">
                  <div class="wechatName">{{item.wechat_name}}</div>
                  <div class="cusSerBtn" v-if="selectGame.sys_service_type === 2">
                    联系客服
                  </div>
                  <div class="wechatNumber" v-if="item.type===0" >
                    <div>微信号：{{item.wechat_number}}</div>
                    <span><img src="@/assets/image/Home/sellPop/vouchIcon3.png" alt="">点击复制</span>
                  </div>
                  <input type="text" id="input"/>
                  <div class="wechatTip" style="background: #ffa45a" v-if="item.status === 1">营业中</div>
                  <div class="wechatTip" v-else-if="item.status === 2">歇业中</div>
                  <div class="wechatTip" v-else-if="item.status === 3">冻结中</div>
                </div>
              </div>
            </div>-->
      <div class="card">
        <div class="title">
          <span></span>
          交易说明
        </div>
        <div class="ql-container ql-snow">
          <p class="content ql-editor" v-html="selectGame.media_guarantee_trade_show"></p>
        </div>
      </div>

    </div>

    <div class="explanation" @click="explanationShow = true">中介介绍</div>

    <!--  中介担保介绍  -->
    <el-dialog
        :visible.sync="explanationShow"
        custom-class="explanationDialog"
        top="10vh"
        :show-close="false"
        center
    >
      <div id="explanationDialog">
        <img class="content" src="../../../assets/image/Home/sellPop/vouchIntroduce.png" alt="">
        <img class="btn" @click="explanationShow = false" src="@/assets/image/AccountDeal/tipClose.png" alt="">
      </div>
    </el-dialog>

  </div>
</template>
<script>

import breadcrumb from "@/components/breadcrumb";
import gameList from "@/components/gameList/index"
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from "@/request/customer/util";
import {apiGameInfo} from "@/request/API";
import { getServiceListApi } from "@/request/im";
export default {
  name: 'vouch',
  props: {},
  components: {
    breadcrumb,
    gameList
  },
  data() {
    return {
      // gameList 、 merchantList 、 merchantInfo
      step: 1,
      // 面包屑
      breadcrumbList: [
        {name: '我要卖'},
        {link: 'vouch', name: '担保中介'}
      ],
      // 选择的游戏
      selectGame: '',
      //弹窗
      explanationShow: false,
      cursList: []
    }
  },
  methods: {
    onlineCusSer(game, item) {
    },
    /**
     * 点击游戏事件
     * @param game
     */
    async gameClick(game, next, sLetter,is_search_click,original_key_word) {
      this.$sensorsTrack.VouchGameSelect(game.game_id,game.game_name,is_search_click,original_key_word)
      if (game.game_name === '无板块游戏') {
        this.selectGame = game
      }else{
        await this.getGameInfo(game.game_id).then(res=>{
          this.selectGame = res.data
        })
      }
      console.log(this.selectGame.sys_service_type);
      if (this.selectGame.sys_service_type === 2) {
        this.getcustomercarelist()
      }
      if (this.selectGame.sys_service_type === 3) {
        this.getcustomercarelistForNewIM()
      }
      this.step++
      this.$router.push({
        path: '/vouch',
        query: {
          game_id: game.game_id,
        },
      })
    },
    /**
     * 返回到游戏列表
     */
    backBtn() {
      this.step--
      this.$router.push({
        path: '/vouch',
      })
    },

    /**
     * 复制微信号
     * @param text 要复制的文本
     */
    copyWechat(text) {
      var text = text;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: '复制成功'
      })
    },

    customClicks(item) {
      if (item.isonline == 1 || item.session_info.status === 0) {
        this.$openIM({
          id: item.id,
          code: this.selectGame.game_alias,
          gameAlias: this.selectGame.game_alias,
          serviceId: item.user_id || item.session_info?.user_id,
          game_id: this.selectGame.game_id,
          im_type: this.selectGame.sys_service_type
        })
      } else {
        this.$message({
          center: true,
          type: 'error',
          message: "当前客服不在线"
        })
      }
    },
    /**
     * @description: 获取客服分组列表
     * @return {*}
     */
    cueGrouplist() {
      chatApi.grouplist({
        msg: chatApi.encryptMsg({
          format: 'json',
          type: 3
        })
      }).then(res => {
        // console.log('客服分组列表',JSON.parse(Decrypt(res.result)));
      }).catch(err => {
      })
    },
    /**
     * @description: 根据分组标识获取客服列表
     * @return {*}
     */
    getcustomercarelist() {
      chatApi.getcustomercarelistbycode({
        msg: chatApi.encryptMsg({
          format: 'json',
          type: 3,
          code: this.selectGame.game_alias
        })
      }).then(res => {
        let data = JSON.parse(Decrypt(res.result))
        this.cursList = data.customercarelist
        // console.log(data);
      }).catch(err => {
      })
    },
    getcustomercarelistForNewIM() {
      getServiceListApi({
        game_code: this.selectGame.game_alias,
        agency_id: 1
      }).then(res => {
        let data = res.data
        let online = [],office = []
        data.forEach(item => {
          if(item?.session_info?.status == 0){
            online.push(item)
          }else{
            office.push(item)
          }
        });
        let list = []
        // if(online.length>1){
        //   list = this.randomSort(online)
        // } else {
        //   list = online
        // }
        this.cursList = [...online,...office]
      }).catch(err => {
      })
    },
    customClick(item) {
      if (item.is_work === 0) {
        this.$message({
          center: true,
          type: 'error',
          message: "当前客服不在线"
        })
      } else {
        this.$openIM({
          id: item.id,
          code: this.selectGame.game_alias,
          gameAlias: this.selectGame.game_alias,
          game_id: this.selectGame.game_id,
        })
        // this.$accessLink(item.work_id)
        // window.open(`${item.work_id}?u_cust_id=${this.$store.state.userData.user_id}&u_cust_name=${this.$store.state.userData.nickname}`, '_blank')
      }
    },
   async getGameInfo(game_id){
      return new Promise(resolve=>{
        apiGameInfo({
          id: game_id
        }).then(res=>{
          resolve(res)
        })
      })
    }
  },
  mounted() {

  },
  watch: {},
  computed: {},
  beforeRouteEnter(to,from,next){
    next((vm) => {
      vm.$sensorsTrack.VouchView(from.name)
    })
  }
}
</script>

<style lang="less">
.explanationDialog {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  max-height: 660px;
  background: transparent;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  #explanationDialog {
    width: 1157px;

    .content {
      width: 100%;
      object-fit: contain;
    }

    .btn {
      position: absolute;
      top: 15px;
      right: -75px;
      cursor: pointer;
    }
  }

}
</style>
<style lang='less' scoped>
.ql-container {
  border: none !important;
}

.vouch {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 1200px;
  margin: 0 auto 32px;

  .header {
    width: 1200px;
    height: 100px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    padding: 0 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .headTitle {
      display: flex;
      flex-direction: row;
      align-items: center;

      .headIcon {
        width: 42px;
        height: 42px;
        object-fit: contain;
      }

      .headText {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: CENTER;
        color: #FFFFFF;
        margin: 0 24px 0 10px;
      }

      .headTip {
        height: 28px;
        line-height: 28px;
        padding: 0 12px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.24);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
      }
    }

    .headBack {
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      box-sizing: border-box;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .introduce {
    margin: 0 0 18px;

    .introduceHead {
      margin: 18px 0 4px;
    }

    .introduceBody {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .IB_card {
        margin: 3px 0 0;
        width: 640px;
        height: 144px;
        padding: 23px 34px 23px 43px;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .card_title {
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: var(--primary, #FF5A1F);
          line-height: 20px;

          span {
            display: inline-block;
            width: 4px;
            height: 14px;
            background: var(--primary, #FF5A1F);
            margin: 0 14px 0 0;
          }
        }

        .card_text {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #5b5b5b;
          line-height: 25px;
        }

        .card_tip {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--primary, #FF5A1F);
          line-height: 16px;
        }
      }

      img {
        cursor: pointer;
      }
    }
  }

  .gameInfo {
    width: calc(100% - 40px);
    padding: 30px 20px 100px;
    background: var(--bg-card, #FFFFFF);

    .select {
      padding: 0 0 30px 18px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .img {
        width: 80px;
        height: 80px;
        margin: 0 25px 0 0;
        border-radius: 4px;
        object-fit: cover;
        box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
      }

      .info {
        margin: 0 100px 0 0;

        .name {
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-main, #111827);
          margin: 0 0 5px;
        }

        .cost {
          max-width: 600px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .btn {
        width: 160px;
        height: 40px;
        line-height: 40px;
        background: var(--primary, #FF7A1A);
        border-radius: 4px;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: CENTER;
        color: #FFFFFF;
        cursor: pointer;
        box-shadow: 0 8px 16px rgba(255, 122, 26, 0.16);
      }


    }

    /*    .wechatList {
          margin: 5px 0 25px;

         > .title {
            display: flex;
            align-items: center;
            padding: 9px 23px;
            background: #ffe6d7;
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: #e57d28;
            margin: 0 0 14px;
            span {
              margin: 0 7px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 600;
              color: #9e3a00;
              display: flex;
              align-items: center;
              img {
                width: 14px;
                height: 14px;
                margin: 0 7px 0 0 ;
              }
            }
          }

          .wehcatBox{
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            .wechatItem{
              width: 224px;
              height: 272px;
              display: flex;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              margin: 14px 4px 10px;
              padding:  10px 0;
              border-radius: 4px;
              box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.10);
              position: relative;
              .wechatType{
                height: 34px;
                width: 125px;
                text-align: center;
                line-height: 34px;
                margin: 0 0 7px;
                border-radius: 4px;
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                color: #000000;
              }
              .wechatImg{
                width: 150px;
                height: 150px;
              }
              .wechatName{
                width: 150px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Semibold;
                font-weight: 600;
                color: #ffffff;
                margin: 0 0 15px;
                background: #98c785;
              }
              .cusSerBtn{
                display: block;
                width: 121px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background: #ffdb51;
                border-radius: 4px;
              }
              .wechatNumber{
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #000000;
                line-height: 14px;
                width: 150px;
                text-align: center;
                span{
                  display: block;
                  text-align: center;
                  min-width: 72px;
                  margin-top: 10px;
                  font-size: 14px;
                  font-family: PingFang SC, PingFang SC-Medium;
                  font-weight: 500;
                  color: #000000;
                  line-height: 14px;
                  img{
                    width: 13px;
                    height: 13px;
                    margin: 0 3px 0 0;
                  }
                }
              }
              .wechatTip{
                position: absolute;
                width: 63px;
                height: 22px;
                line-height: 22px;
                background: #cecece;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: CENTER;
                color: #ffffff;
                border-radius: 4px 0 4px 0;
                top: 0;
                left: 0;
              }

            }
          }

        }*/

    .wechatList {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 6px;
      margin: 5px 0 25px;

      .cusSer {
        width: 168px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        margin: 20px 9px 0;
        cursor: pointer;

        .info {
          padding: 15px 0 0;
          display: flex;
          flex-direction: column;
          align-items: center;

          .name {
            width: 100px;
            height: 26px;
            line-height: 26px;
            background: var(--bg-dark, #1A1D24);
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            margin: 0 0 10px;
          }

          .qr_code {
            margin: 0 0 5px;

            img {
              width: 120px;
              height: 120px;
            }
          }

          .tip {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--success, #22C55E);
            line-height: 14px;
            margin: 0 0 10px;

            img {
              margin: 0 7px 0 0;
              width: 13.16px;
              height: 12.58px;
            }
          }

        }

        .btn {
          display: block;
          width: 121px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: var(--primary, #FF7A1A);
          border-radius: 4px;
          margin: 0 auto 15px;
          color: #FFFFFF;
        }

      }

      .cusSer:hover {
        border: 1px solid var(--primary, #FF5A1F);
      }

      .QQSGcusSer {
        width: 163px;
        min-height: 170px;

        .cus-head {
          margin: 20px auto 10px;
          width: 30px;
          height: 30px;
        }

        .name {
          padding: 0 10px;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-main, #111827);
        }

        .division {
          width: calc(100% - 22px);
          height: 1px;
          margin: 20px auto;
          background-color: var(--border-soft, #E8E4DE);
        }
      }


      .afterWork {
        filter: grayscale(1);
        cursor: default;
      }
    }

    .card {
      padding: 28px 0 29px 32px;
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      box-shadow: 0 4px 12px rgba(26, 29, 36, 0.08);

      .title {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: var(--warning, #F59E0B);
        margin: 0 0 24px;

        span {
          display: inline-block;
          width: 4px;
          height: 14px;
          background: var(--warning, #F59E0B);
          margin: 0 14px 0 0;
        }
      }

      .content {
        .item {
          display: flex;
          margin: 0 0 13px;

            .square {
              width: 9px;
              height: 9px;
            background: var(--text-secondary, #5A5F6B);
            margin: 7px 14px 0 0;
          }

          .text {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);

            span {
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--primary, #FF7A1A);
            }
          }

        }
      }
    }
  }

  #input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -10;
  }

  .explanation {
    cursor: pointer;
    position: absolute;
    top: 258px;
    left: -39px;
    width: 39px;
    height: 126px;
    background: var(--bg-dark, #1A1D24);
    box-shadow: -3px 0px 8px 0px rgba(26, 29, 36, 0.24);
    border-radius: 4px 0px 0px 4px;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

}
</style>
